<template>
<div class="header">
  <!-- logo -->
  <div class="header__logo_outer">
    <div class="header__logo_inner">
      <a href="/"><img src="../assets/logo.jpg" /></a>
    </div>

    <!-- underlogo menu -->
    <div class="header__logomenu">
      <!-- Здравствуйте, Гость -->
      <span class="header__welcome">
        <template v-if="nicknameFromCookie">
          <b>Здравствуйте, {{nicknameFromCookie}}</b> ( <a @click.prevent="clearCookies()" href="index.php?act=Unlog">Выход</a> )
        </template>
        <template v-else>
          <b><a style="text-decoration: none;" href="/main/">Realms.Ru</a> · <a>Правила форума</a></b>
        </template>
      </span>


      <div class="header__menu_rightalign">
        <a class="header__menuitem">Панель управления</a>{{' | '}}
        <template v-if="nicknameFromCookie">
          <a class="decoration_2020" href="index.php?act=Msg">Новых сообщений: 0</a>{{' | '}}
        </template>
        <template v-else>
          <a class="header__menuitem">Пейджер недоступен</a>{{' | '}}
        </template>
        <a class="header__menuitem">Новые посты</a>{{' | '}}
        <a class="header__menuitem">Навигация</a>
      </div>
    </div>
  </div>

  <div style="text-align: center;">
    <div class="header__logomenu2">
      <a href="/main/">Realms.ru</a>{{' | '}}
      <a href="http://rpgplanet.ru">RPG Planet</a>{{' | '}}
      <a class="decoration_2020" href="http://www.city-of-masters.ru/forums/index.php?showtopic=3675&view=getnewpost">Обсуждение в {{new Date().getFullYear()}}</a>{{' | '}}
      <a class="decoration_2020" href="https://t.me/rpgplanetfoyer">Telegram-канал</a>{{' | '}}
      <a>Магазин</a>{{' | '}}
      <a>Календарь</a>
    </div>
  </div>

  <!-- Breadcrumbs -->
  <div class="header__breadcrumbs">
    <img style="vertical-align:middle" src="../assets/nav.gif" /> <a href="/">RP Realms</a>
    <template v-for="breadcrumb in breadcrumbs"> » <a :href="'index.php?' + getBreadLink(breadcrumb) + breadcrumb[0]">{{htmlDecode(breadcrumb[1])}}</a> </template>
  </div>

  <!-- Добро пожаловать; Ваш последний визит: ... [Имя пользователя] [******] логин-->
  <template v-if="displayLoginBox">
    <div class="login__div">
      <div style="width: 50%; padding-bottom: 4px;">Добро пожаловать; Ваш последний визит был в 2004</div>
      <div style="width: 50%; text-align: right;">
        <!-- if logged out, show login form -->
        <template v-if="nicknameFromCookie == null">
          <span style="margin-right: 4px;"><b>Быстрый вход</b></span>
          <input type="text" ref="login" name="login" placeholder="Ваш Ник" size="10" v-on:keyup.enter="sendLogin()">
          <input type="password" ref="password" name="password" placeholder="" size="10" v-on:keyup.enter="sendLogin()">
          <a class="text-button" @click="sendLogin()">ОК</a>
        </template>
        <!-- if logged in, show searchbox -->
        <template v-else>
          <input type="text" ref="search" name="search" placeholder="Что ищем?" size="20" v-on:keyup.enter="sendSearch()">
          <a class="text-button" @click="sendSearch()">ОК</a>
        </template>
      </div>
    </div>
</template>

</div>
</template>


<script>
export default {
  props: ['breadcrumbs', 'displayLoginBox'], // now use {{breadcrumbs}}
  data: function() {
    return {
      nicknameFromCookie: null,
      idFromCookie: null,
      hashFromCookie: null,
    }
  },
  async created() {
    this.nicknameFromCookie = this.$cookies.get('realmsnickname');
    this.idFromCookie = this.$cookies.get('realmsmid');
    this.hashFromCookie = this.$cookies.get('realmshash');
  },
  methods: {
    getBreadLink(breadcrumb) {
      switch (breadcrumb[2]) {
        case 'cat':
          return "act=SC&c=";
        case 'for':
          return "act=SF&f=";
      }
    },
    async sendLogin() {
      //console.log("Sending login: " + this.$refs.login.value + "\npassword: " + this.$refs.password.value);
      const requestOptions = {
        //credentials: "same-origin",
        //credentials: 'include',
        mode: 'same-origin',
        method: "POST",
        headers: {
          //"Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          login: this.$refs.login.value,
          password: this.$refs.password.value,
        })
      };
      const response = await fetch(this.getNodePath() + 'login/', requestOptions);
      const rcvdData = await response.json();
      if (rcvdData['loginSuccess'] === true) {
        console.log("login success");
        this.$refs.login.value = "";
        this.$refs.password.value = "";
        this.nicknameFromCookie = this.$cookies.get('realmsnickname');
        this.idFromCookie = this.$cookies.get('realmsmid');
        this.hashFromCookie = this.$cookies.get('realmshash');
      } else {
        this.$refs.password.value = "";
        console.log("login failed");
        console.log(rcvdData);
        if (rcvdData['tooManyAttempts']) {
          console.log("wait for 1 minute");
          this.$refs.login.value = "ПОДОЖДИТЕ 1 МИН";
        }
      }
    },
    clearCookies() {
      this.nicknameFromCookie = null;
      this.idFromCookie = null;
      this.hashFromCookie = null;
      this.$cookies.remove('realmsnickname');
      this.$cookies.remove('realmsmid');
      this.$cookies.remove('realmshash');
    },
    printCookies() {
      let keys = this.$cookies.keys();
      keys.forEach((item, i) => {
        console.log(item);
      });
    },
    sendSearch() {
      this.$refs.search.value = "еще не работает :^)";
    }
  }
}
</script>

<style lang="scss">
@import "../skin-blue.scss";
@import "./Header.scss";
</style>
